export default class BuyoutOption {
  constructor(
  isSure,
  date,
  externalId,
  currencyCode,
  rate,
  paymentDate,
  ) {
    this.isSure = isSure;
    this.date = date;
    this.externalId = externalId;
    this.currencyCode = currencyCode;
    this.rate = rate;
    this.paymentDate = paymentDate;
  }

  static createFromData(data) {
    if (data == null) return null;
    return new BuyoutOption(
      data.isSure,
      data.date,
      data.externalId,
      data.currencyCode,
      data.rate,
      data.paymentDate,
    )
  }

  static createNew() {
    return new BuyoutOption(
      false,
      null,
      null,
      null,
      null,
      null
    );
  }

}
